import styled, { css } from "styled-components/native";
import { light_black, spacing_l, white_smoke } from "../../StyleHelpers";
import { StyleSheet } from "react-native";
import { Props, StyledProps } from "./model";

export const StyledContainer = styled.View<Props>`
	flex-direction: column;
	backdrop-filter: blur(10px);
	justify-content: center;
	z-index: 1000;
	width: 100%;
	top: 0;
	position: fixed;
	height: ${(props) => (props.isNarrow ? "5rem" : "112px")};
	${(props) =>
		!props.screenTitle && !props.titleLogo && !props.search && props?.demoOptions
			? css`
					background-color: transparent;
				`
			: css`
					background-color: rgba(0, 0, 0, 0.8);
				`}
	${(props) =>
		props.isNarrow &&
		props.isNav &&
		!props.isRHD &&
		css`
			width: calc(100% - 80px);
			left: 80px;
		`}

	${(props) =>
		props.isNarrow &&
		props.isNav &&
		props.isRHD &&
		css`
			width: calc(100% - 80px);
			right: 80px;
		`}
`;

export const StyledTextContainer = styled.View<Props>`
	justify-content: center;
	align-items: left;
	flex: 1;
	${(props) =>
		props.addTitleMarginLeft &&
		css`
			padding-left: ${props.isNarrow && props.isNav ? "40px" : spacing_l};
		`};
`;

export const StyledText = styled.Text<any>`
	white-space: nowrap;
	display: flex;
	flex-direction: column;
	width: 90%;
`;

export const StyledIconContainer = styled.View<StyledProps>`
	height: ${(props) => (props.isNarrow ? "80px" : "112px")};
	align-items: center;
	justify-content: center;
	${(props) =>
		props.leftIconWidth &&
		css`
			width: ${props.leftIconWidth}px;
		`}

	${(props) =>
		!props.leftIconWidth &&
		css`
			width: 120px;
		`}
`;

export const StyledCloseContainer = styled.View<StyledProps>`
	height: 112px;
	width: 120px;
`;

export const StyledIconRenderer = styled.Image<StyledProps>`
	height: ${(props) => (props.isNarrow ? "46px" : "56px")};
	width: ${(props) => (props.isNarrow ? "48px" : "56px")};
`;

export const StyledLoading = styled.View`
	width: 662px;
	height: 64px;
	overflow: hidden;
	border-radius: 16px;
`;

export const styles = StyleSheet.create({
	innerContainer: {
		flexDirection: "row",
	},
	backIcon: {
		resizeMode: "contain",
	},
	rightImage: {
		marginRight: 93,
		borderRadius: 8,
		borderWidth: 1,
		borderColor: "white",
		borderStyle: "solid",
	},
	screenLabel: {
		borderColor: "white",
		textAlign: "left",
	},
	titleBody: {
		fontSize: 18,
		textAlign: "left",
		opacity: 0.8,
	},
	titleBodyNarrow: {
		fontSize: 16,
		textAlign: "left",
		opacity: 0.8,
	},
	centerImage: {
		textAlign: "center",
		justifyContent: "center",
		width: 120,
		alignItems: "center",
	},
	rightImageContainer: {
		flexDirection: "row",
		justifyContent: "flex-end",
		alignItems: "center",
	},
	narrowImage: {
		textAlign: "center",
		width: "auto",
	},
	searchTextInput: {
		height: 66,
		backgroundColor: light_black,
		fontSize: 24,
		color: white_smoke,
		paddingLeft: 30,
	},
	outlineStyle: {
		borderRadius: 33,
	},
	stylesPreview: {
		height: 112,
		marginLeft: 40,
		justifyContent: "center",
	},
	narrowSearchTextInput: {
		fontSize: 26,
		fontStyle: "normal",
		fontWeight: "500",
		lineHeight: 35,
		color: white_smoke,
		paddingLeft: 8,
		backgroundColor: light_black,
	},
});
